import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField as MuiTextField } from "@mui/material";
import { persianToEnglishDigits } from "functions/persianToEnglishDigits";
import { useState } from "react";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";
import classes from "./style.module.scss";

const priceFormat = (value) => {
  if (!value) return "";
  return Number(value.replaceAll(",", "")).toLocaleString();
};

const TextField = ({
  name,
  control,
  required = false,
  fullWidth = true,
  variant = "outlined",
  label,
  className = "",
  formatAsPrice = false,
  number = false,
  size = "small",
  type = "text",
  icon = null,
  theme = 1,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <MuiTextField
            {...field}
            className={`${className} ${theme === 2 && classes.fieldTheme2}`}
            required={required}
            fullWidth={fullWidth}
            variant={variant}
            label={label}
            error={!!error}
            size={size}
            helperText={error?.message}
            type={isPassword ? (showPassword ? "text" : "password") : type}
            value={field.value ? (formatAsPrice ? priceFormat(field.value) : field.value) : ""}
            onChange={(e) => {
              let rawValue = e.target.value.replaceAll(",", "");
              rawValue = persianToEnglishDigits(rawValue);
              if (number && !/^[۰-۹0-9]*$/.test(rawValue)) return;
              field.onChange(rawValue);
            }}
            InputLabelProps={{
              shrink: !!field.value,
              sx: {
                "& .MuiInputLabel-asterisk": {
                  color: rest?.disabled ? "gray" : "red",
                },
              },
            }}
            InputProps={{
              endAdornment: isPassword ? (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ) : icon ? (
                <InputAdornment position="end">{icon}</InputAdornment>
              ) : null,
            }}
            {...rest}
          />
        )}
      />
    </RightToLeftLayout>
  );
};

export default TextField;
